export const resortPosition = (array) => {
  if(!array) return

  return array.map((item, index) => ({ ...item, position: index + 1 }))
}